import { isObject } from './typeGuards'

export function cloneDeep(obj: object) {
  return JSON.parse(JSON.stringify(obj))
}

function toCamel(s: string) {
  return s.replace(/([-_ ][a-z])/gi, ($1) => {
    return $1.toUpperCase().replaceAll(/[-_ ]/g, '')
  })
}

export function deepMapKeysToCamel<T>(o: unknown): T {
  if (isObject(o)) {
    const n: Record<string, unknown> = {}

    Object.keys(o as Record<string, unknown>).forEach((k) => {
      n[toCamel(k)] = deepMapKeysToCamel((o as Record<string, unknown>)[k])
    })

    return n as T
  } else if (Array.isArray(o)) {
    return o.map((i: unknown) => {
      return deepMapKeysToCamel(i)
    }) as T
  }

  return o as T
}
